import React from 'react';
import { Container } from '@hover/blueprint';
import { MEASURE_ROOF_STEPS } from '../../../constants';
import Step from './Step';

const Steps: React.FC = () => (
  <Container maxW="100%" w="100%" centerContent mb={1000} px={0}>
    {MEASURE_ROOF_STEPS.map(step => (
      <Step step={step} key={step.id} />
    ))}
  </Container>
);

export default Steps;
